module.exports = __webpack_public_path__ + "static/media/clicky3.1b271d1d.gif";